/**
 * Cookie 管理工具
 */
export class CookieManager {
    /**
     * 設定 Cookie
     * @param name Cookie 名稱
     * @param value Cookie 值
     * @param days 過期天數
     */
    static setCookie(name: string, value: string, days: number = 365): void {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    }

    /**
     * 獲取 Cookie
     * @param name Cookie 名稱
     * @returns Cookie 值或 null
     */
    static getCookie(name: string): string | null {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    /**
     * 刪除 Cookie
     * @param name Cookie 名稱
     */
    static deleteCookie(name: string): void {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    }

    /**
     * 檢查是否已設定「不要再提醒我」選項
     * @returns 是否已設定不再提醒
     */
    static isDontRemindAgain(): boolean {
        return this.getCookie('dont_remind_file_size') === 'true';
    }

    /**
     * 設定「不要再提醒我」選項
     * @param value 是否不再提醒
     */
    static setDontRemindAgain(value: boolean): void {
        this.setCookie('dont_remind_file_size', value.toString());
    }

    /**
    * 檢查特定檔案是否已經提示過
     * @param fileUrl 檔案 URL
     * @returns 是否已經提示過
     */
    static hasShownDialogForFile(fileUrl: string): boolean {
        const shownFiles = this.getCookie('shown_file_dialogs');
        if (!shownFiles) return false;
        try {
            const files = JSON.parse(shownFiles);
            return files.includes(fileUrl);
        } catch {
            return false;
        }
    }

    /**
    * 記錄特定檔案已經顯示過對話框
    * @param fileUrl 檔案 URL
    */
    static markFileAsShown(fileUrl: string): void {
        const shownFiles = this.getCookie('shown_file_dialogs');
        let files: string[] = [];
       
        if (shownFiles) {
            try {
                files = JSON.parse(shownFiles);
            } catch {
                files = [];
            }
        }   
        if (!files.includes(fileUrl)) {
            files.push(fileUrl);
            this.setCookie('shown_file_dialogs', JSON.stringify(files));
        }
    }

    /**
     * 清除已顯示檔案的記錄
     */
    static clearShownFiles(): void {
        this.deleteCookie('shown_file_dialogs');
    }
}
